import { Paths } from '../../lib/constants/path'
import { TripBookingProperties } from '../../lib/types/models/trip-booking/properties.trip-booking'
import { TripFolder } from '../../lib/types/models/trip-folder/trip-folder'

export const constructTripFolderPath = (tripFolderId: number, path = '') =>
  Paths.TRIP_FOLDER_DETAILS_PAGE.replace(':id', tripFolderId.toString()).replace('*', '') + path

export function getTripFolderTripSteps(tripFolder: TripFolder) {
  return (
    TripBookingProperties.sortTripStepsById(
      tripFolder.tripBookings
        .map((t) => t.tripSteps)
        .flat()
        .filter((t) => t.directionality === tripFolder.directionality)
    ) ?? []
  )
}
